var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAdministration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.975 15.097",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.47,5.752A2.876,2.876,0,1,0,3.594,2.876,2.876,2.876,0,0,0,6.47,5.752Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.323,12.049a2.718,2.718,0,0,0,0-1.093l.579-.431a.182.182,0,0,0,.049-.237l-.673-1.165a.182.182,0,0,0-.23-.076l-.673.291A2.853,2.853,0,0,0,12.44,8.8l-.084-.728a.181.181,0,0,0-.18-.162H10.83a.183.183,0,0,0-.181.161l-.084.728a2.853,2.853,0,0,0-.935.541l-.673-.291a.182.182,0,0,0-.23.076l-.673,1.165a.182.182,0,0,0,.049.237l.579.431a2.95,2.95,0,0,0-.055.547,2.864,2.864,0,0,0,.055.546l-.579.431a.182.182,0,0,0-.049.237l.673,1.165a.182.182,0,0,0,.23.076l.673-.291a2.853,2.853,0,0,0,.935.541l.084.728a.181.181,0,0,0,.18.162h1.346a.182.182,0,0,0,.181-.161l.084-.728a2.853,2.853,0,0,0,.935-.541l.673.291a.182.182,0,0,0,.23-.076l.673-1.165a.182.182,0,0,0-.049-.237Zm-2.819.712h0A1.258,1.258,0,1,1,12.761,11.5,1.258,1.258,0,0,1,11.5,12.761Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.47,7.905C4.212,7.908,0,9.019,0,11.143v1.078a.719.719,0,0,0,.719.719H6.682A5.021,5.021,0,0,1,7.87,8.018,9.789,9.789,0,0,0,6.47,7.905Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAdministration);
export default __webpack_public_path__ + "static/media/UserAdministration.9c654241e745e9ce748c80a2ef833d13.svg";
export { ForwardRef as ReactComponent };